exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /var/www/beauty-shop.ru/~/core-js/modules/_wks-ext.js
// module id = 686
// module chunks = 32